// French (fr) — partial locale.
//
// Phoenix Tracker is Arabic/English-first; French ships covering the
// navigation chrome + the most-visited surfaces. Any key NOT present
// here falls back to English automatically (i18next fallbackLng, see
// src/i18n.js). Expand this file over time — never delete a key to
// "fall back"; just leave it out.
const translation = {
  "appName": "Phoenix",

  "common": {
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "close": "Fermer",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "edit": "Modifier",
    "delete": "Supprimer",
    "add": "Ajouter",
    "confirmDelete": "Supprimer cet élément ?",
    "actions": "Actions",
    "clear": "Effacer",
    "show": "Afficher",
    "hide": "Masquer"
  },

  "breadcrumb": {
    "label": "Fil d'Ariane",
    "home": "Accueil",
    "workout": "Entraînement",
    "history": "Historique",
    "session": "Séance",
    "library": "Bibliothèque",
    "exercise": "Exercice",
    "templates": "Modèles",
    "newSession": "Nouvelle séance",
    "phases": "Phases",
    "settings": "Réglages",
    "profile": "Profil",
    "habits": "Habitudes",
    "physique": "Analyse physique",
    "sleep": "Recalage du sommeil",
    "goalPace": "Rythme objectif",
    "quizHistory": "Historique",
    "editProfile": "Modifier le profil",
    "news": "Actus",
    "social": "Social",
    "tech": "Tech",
    "newsHealth": "État des sources",
    "article": "Article",
    "gamesWordle": "Wordle",
    "gamesQuestions": "Questions",
    "gamesQuiz": "Quiz",
    "gamesSpy": "Espion",
    "scoreboard": "Classement",
    "youtube": "YouTube",
    "health": "Profil santé",
    "learning": "Apprentissage",
    "english": "Anglais",
    "englishVocab": "Vocabulaire",
    "englishReview": "Révision",
    "englishCourse": "Cours",
    "englishTutor": "Tuteur",
    "englishSpeak": "Parler",
    "messages": "Messages",
    "message": "Message",
    "friends": "Amis",
    "lifeSearch": "Recherche de vie",
    "people": "Personnes",
    "wishlist": "Envies",
    "tab": {
      "today": "Aujourd'hui",
      "weight": "Poids",
      "water": "Eau",
      "meals": "Repas",
      "measurements": "Mensurations",
      "photos": "Photos",
      "progress": "Progrès"
    }
  },

  "settings": {
    "title": "Réglages",
    "back": "Retour",
    "close": "Fermer",
    "crumb": "Réglages",
    "replayTour": "Revoir la visite guidée",
    "sections": {
      "preferences": "Préférences",
      "appearance": "Apparence",
      "voice": "Voix",
      "notifications": "Notifications",
      "profile": "Profil",
      "training": "Entraînement",
      "app": "Application",
      "developer": "Développeur"
    },
    "app": {
      "checkUpdates": {
        "label": "Vérifier les mises à jour",
        "description": "Force l'application à récupérer la dernière version. La page se recharge après ~3 secondes."
      }
    },
    "voice": {
      "englishLabel": "Voix anglaise",
      "arabicLabel": "Voix arabe",
      "previewing": "Aperçu…"
    },
    "appearance": {
      "theme": "Thème",
      "themeLight": "Clair",
      "themeDark": "Sombre",
      "themeBlack": "Noir",
      "autoTheme": "Changer selon l'heure",
      "primaryColor": "Couleur principale",
      "font": "Police"
    }
  },

  "reminders": {
    "title": "Rappel quotidien",
    "description": "On te rappellera une fois par jour de faire le point.",
    "time": "À",
    "enable": "Activer les rappels",
    "disable": "Désactiver les rappels",
    "sendTest": "Envoyer un test"
  },

  "workout": {
    "title": "Entraînement",
    "subtitle": "Entraîne-toi malin, note vite.",
    "uploading": "Téléversement…"
  },

  "finance": {
    "title": "Finances"
  },

  "healthProfile": {
    "title": "Profil santé"
  },

  "reports": {
    "title": "Rapports",
    "subtitle": "Rapport markdown multi-modules pour n'importe quelle période.",
    "preset": "Préréglage",
    "startDate": "Début",
    "endDate": "Fin",
    "generate": "Générer le rapport",
    "includes": "Chaque rapport inclut :"
  },

  "news": {
    "title": "Actus",
    "empty": "Aucun article en cache pour l'instant.",
    "savedEmpty": "Aucun article enregistré.",
    "savedShowOnly": "Afficher seulement les enregistrés",
    "savedShowAll": "Afficher tous les articles",
    "markAsRead": "Marquer comme lu",
    "markAsUnread": "Marquer comme non lu",
    "read": "Lu",
    "unread": "Non lu"
  },

  "sports": {
    "title": "Matchs",
    "filterAll": "Toutes les ligues",
    "filterFavourites": "Favoris",
    "filterMyTeams": "Mes équipes",
    "favourite": "Ajouter aux favoris",
    "unfavourite": "Retirer des favoris",
    "leaguesLabel": "Ligues",
    "myTeamsLabel": "Mes équipes",
    "viewStandings": "Classement"
  },

  "phoenixTracker": {
    "title": "Phoenix Tracker",
    "tabs": {
      "today": "Aujourd'hui",
      "weight": "Poids",
      "water": "Eau",
      "meals": "Repas",
      "measurements": "Mensurations",
      "workouts": "Séances",
      "photos": "Photos",
      "news": "Actus",
      "social": "Social",
      "progress": "Progrès",
      "profile": "Profil"
    },
    "today": {
      "greetingNamed": "Salut {{name}} 👋",
      "greetingPlain": "Salut 👋",
      "weight": "Poids",
      "meals": "Repas",
      "workout": "Séance",
      "moodTitle": "Comment tu te sens aujourd'hui ?",
      "energyTitle": "Et ton énergie ?",
      "mood": "Humeur",
      "energy": "Énergie",
      "moodWord1": "Affreux",
      "moodWord2": "Bof",
      "moodWord3": "Ça va",
      "moodWord4": "Bien",
      "moodWord5": "Super",
      "energyWord1": "Vidé",
      "energyWord2": "Faible",
      "energyWord3": "Moyen",
      "energyWord4": "Haute",
      "energyWord5": "À bloc",
      "couplesTitle": "Toi + {{name}}",
      "dailyQuestion": "Question du jour",
      "wordle": "Wordle",
      "quiz": "Quiz",
      "currentWeight": "Poids actuel",
      "headline": "À la une",
      "more": "Plus"
    },
    "phases": { "title": "Phases" }
  },

  "friends": {
    "title": "Amis"
  },

  "lifeSearch": {
    "title": "Recherche de vie"
  },

  "people": {
    "title": "Personnes"
  },

  "wishlist": {
    "title": "Envies"
  },

  "profile": {
    "openMenu": "Ouvrir le menu du profil",
    "greeting": "Bonjour, {{name}} 👋",
    "fallbackName": "ami",
    "editProfile": "Modifier le profil / objectifs",
    "workouts": "Séances",
    "measurements": "Mensurations",
    "signOut": "Se déconnecter"
  },

  "games": {
    "title": "Jeux",
    "wordle": { "title": "Wordle", "tabLabel": "Wordle" },
    "questions": { "title": "Questions", "tabLabel": "Questions" },
    "quiz": { "title": "Quiz", "tabLabel": "Quiz" },
    "spy": {
      "title": "Espion",
      "tabLabel": "Espion",
      "players": "Joueurs",
      "playerPlaceholder": "Joueur {{n}}",
      "addPlayer": "Ajouter un joueur",
      "removePlayer": "Retirer le joueur",
      "computerPlayers": "Bots",
      "addBot": "Ajouter un joueur ordinateur",
      "removeBot": "Retirer un joueur ordinateur",
      "botName": "Ordinateur {{n}}",
      "interrogate": "Interroge l'ordinateur",
      "discussion": "Discussion",
      "askNow": "Demander maintenant",
      "feedHint": "Les bots demandent tout seuls — réponds à voix haute ou ici.",
      "replyPlaceholder": "Réponds à l'ordinateur…",
      "nextQuestion": "Question suivante",
      "replyToTarget": "Réponds à {{name}}…",
      "askPlaceholder": "Pose une question… (ou touche envoyer)",
      "botAsk": "Laisse l'ordinateur poser une question",
      "botFailed": "…(pas de réponse — réessaie)",
      "modeLocal": "Un téléphone",
      "modeOnline": "Salon en ligne",
      "yourName": "Ton nom",
      "createRoom": "Créer un salon",
      "joinRoom": "Rejoindre un salon",
      "codePlaceholder": "CODE",
      "roomNotFound": "Aucun salon avec ce code.",
      "roomInProgress": "Cette partie a déjà commencé.",
      "roomCode": "Code du salon",
      "shareCode": "Partage ce code pour que les autres rejoignent.",
      "inviteFriends": "Inviter des amis",
      "invite": "Inviter",
      "invited": "Envoyé ✓",
      "host": "Hôte",
      "waitingHost": "En attente du démarrage par l'hôte…",
      "voteWho": "Qui est l'espion ?",
      "computerTurn": "Au tour de l'ordinateur de demander",
      "votes": "Votes",
      "leaveRoom": "Quitter le salon",
      "roundTime": "Durée de la manche",
      "minutes": "{{n}} min",
      "start": "Commencer la manche",
      "needMore": "Ajoute au moins {{n}} joueurs pour commencer.",
      "passTo": "Passe le téléphone à {{name}}",
      "tapToReveal": "Touche pour voir ta carte",
      "youAreSpy": "Tu es l'espion 🕵️",
      "spyHint": "Fonds-toi dans le groupe et devine le lieu.",
      "theLocation": "Le lieu",
      "yourRole": "Ton rôle : {{role}}",
      "hideAndPass": "Cacher et passer",
      "startRound": "Tout le monde a vu — commencer",
      "discussHint": "Posez-vous des questions. Trouvez l'espion avant la fin du temps.",
      "timeUp": "Temps écoulé ! Votez pour l'espion.",
      "pause": "Pause",
      "resume": "Reprendre",
      "addMinute": "+1 min",
      "reveal": "Révéler l'espion",
      "theSpy": "L'espion était",
      "theSpies": "Les espions étaient",
      "playAgain": "Rejouer",
      "newSetup": "Nouvelle partie",
      "howToTitle": "Comment jouer à Espion",
      "gotIt": "Compris",
      "whoWon": "Qui a gagné cette manche ?",
      "outcomeCaught": "On a démasqué l'espion",
      "outcomeGuessed": "L'espion a deviné le lieu",
      "outcomeEscaped": "L'espion s'en est sorti",
      "skipLog": "Passer — ne pas enregistrer",
      "logged": "Manche enregistrée",
      "scoreboard": "Classement",
      "noResults": "Aucune manche enregistrée.",
      "bestBluffer": "Meilleur bluffeur",
      "mostCaught": "Le plus démasqué",
      "colPlayer": "Joueur",
      "colGames": "Parties",
      "colSpyWins": "Victoires espion",
      "colCaught": "Démasqué"
    }
  },

  "physique": {
    "title": "Analyse physique",
    "intro": "Envoie une photo et l'IA te dit sur quoi te concentrer.",
    "pick": "Choisir une photo",
    "tryAnother": "Essayer une autre photo",
    "analyzing": "Analyse…",
    "privacy": "Ta photo n'est pas stockée — analysée puis supprimée.",
    "strengths": "Points forts",
    "focusAreas": "À travailler",
    "tips": "Conseils d'entraînement",
    "history": "Analyses précédentes",
    "failed": "Analyse impossible — essaie une photo nette du corps entier.",
    "notPerson": "Ça ne ressemble pas à une photo de corps. Essaie une photo nette du corps entier.",
    "disclaimer": "Conseils d'entraînement uniquement — pas un avis médical."
  },
  "goalPace": {
    "title": "Rythme objectif",
    "settings": "Réglages",
    "sevenDayAvg": "Poids moyen sur 7 jours",
    "daysLeft": "{{n}} jours restants",
    "todayRaw": "aujourd'hui {{v}}",
    "weeklyRate": "Rythme hebdomadaire",
    "bandHint": "Plage saine : {{min}}–{{max}} {{unit}}/semaine",
    "projected": "Projeté à la date cible :",
    "chartTitle": "Moyenne hebdo vs cible",
    "avgLine": "moy. 7 j",
    "targetLine": "Cible",
    "levers": "Leviers quotidiens",
    "steps": "Pas",
    "stepTarget": "Cible {{min}}–{{max}}",
    "logSteps": "Noter les pas du jour",
    "today": "Aujourd'hui",
    "avg7": "moy. 7 j",
    "protein": "Protéines",
    "proteinTarget": "Cible {{g}} g/jour",
    "streak": "Série",
    "buildingBaseline": "Construction de la base",
    "buildingBaselineHint": "{{n}} sur {{need}} pesées. Continue à noter — une tendance a besoin de deux semaines pour avoir du sens.",
    "targetDate": "Date cible",
    "baselineWeight": "Poids de départ ({{unit}})",
    "baselineDate": "Date de départ",
    "goalWeight": "Poids objectif ({{unit}})",
    "optional": "facultatif",
    "note": {
      "tooFast": "La perte dépasse la plage durable depuis 2+ semaines. Cela augmente le risque de perte musculaire et d'énergie — envisage d'alléger le déficit. Plus vite n'est pas mieux ici.",
      "aggressive": "Cet objectif exige un rythme plus rapide que sain dans le temps restant. Un poids réaliste à ta date cible est d'environ {{weight}}.",
      "behind": "Un peu en retard sur le rythme. Le levier, c'est plus de pas et atteindre ta cible de protéines — pas manger moins."
    }
  },
  "sleep": {
    "title": "Recalage du sommeil",
    "endPlan": "Terminer le plan",
    "setupIntro": "Décale ton sommeil progressivement vers un horaire plus sain — un peu plus tôt à chaque étape, maintenu jusqu'à ce que ton corps s'adapte.",
    "current": "Où tu en es maintenant",
    "target": "Où tu veux arriver",
    "bedtime": "Coucher",
    "wake": "Réveil",
    "shiftIncrement": "Décalage par étape",
    "holdDays": "Jours par étape",
    "melatoninOffset": "Mélatonine avant le coucher",
    "dose": "Dose de mélatonine",
    "minutes": "min",
    "days": "jours",
    "hours": "h",
    "startPlan": "Démarrer le plan",
    "disclaimer": "Conseils de bien-être généraux, pas un avis médical. Consulte un médecin avant de prendre de la mélatonine.",
    "todayTargets": "Objectifs de ce soir",
    "stepN": "Étape {{n}}",
    "daysToTarget": "{{n}} jours avant l'objectif",
    "melatonin": "Mélatonine",
    "doseHint": "Dose : {{dose}}",
    "morningLight": "Lumière du matin",
    "melatoninTaken": "Mélatonine prise",
    "windDownDone": "Routine du soir faite",
    "logNight": "Noter la nuit dernière",
    "actualBedtime": "Coucher réel",
    "actualWake": "Réveil réel",
    "quality": "Qualité du sommeil",
    "todayAdherence": "Adhérence :",
    "streakN": "{{n}} jours d'affilée",
    "maintenance": "Maintien",
    "maintenanceTitle": "Tu as atteint ton horaire cible",
    "taperHint": "Garde ce rythme. Tu peux commencer à réduire la mélatonine — essaie de diviser la dose par deux, puis de l'arrêter une fois ton sommeil stabilisé.",
    "chartTitle": "Tendance du coucher",
    "chartTarget": "Cible {{time}}"
  },
  "habits": {
    "title": "Habitudes",
    "manage": "Gérer les habitudes",
    "empty": "Aucune habitude. Ajoutes-en une pour lancer une série.",
    "add": "Ajouter une habitude",
    "editTitle": "Modifier l'habitude",
    "namePlaceholder": "ex. Sport, Lecture, Prière…",
    "icon": "Icône",
    "color": "Couleur",
    "streakN": "série de {{n}} jours",
    "doneOfTotal": "{{done}}/{{total}} fait",
    "manageHint": "Touche une habitude pour la cocher aujourd'hui."
  },

  "messages": {
    "list": {
      "title": "Messages",
      "startHint": "Touche pour discuter",
      "empty": "Aucune conversation — ajoute des amis pour discuter."
    },
    "thread": {
      "empty": "Aucun message avec {{name}} — dis bonjour 👋",
      "placeholder": "Message…",
      "thinkingOfYou": "Je pense à toi",
      "read": "Lu",
      "sent": "Envoyé",
      "typing": "écrit…",
      "online": "en ligne",
      "edit": "Modifier",
      "unsend": "Annuler l'envoi",
      "deleted": "Message supprimé",
      "edited": "modifié",
      "reply": "Répondre",
      "you": "Toi",
      "attachImage": "Envoyer une photo",
      "viewOnceMode": "Mode photo éphémère",
      "tapToView": "Touche pour voir ({{n}}×)",
      "viewOnceSent": "Photo éphémère envoyée ({{n}}×)",
      "imageSeen": "Photo vue — plus disponible"
    },
    "gate": {
      "openInbox": "Ouvrir les messages",
      "close": "OK",
      "viewOncePhoto": "Photo éphémère envoyée — ouvre la conversation pour la voir"
    },
    "notFound": "Message introuvable.",
    "gallery": {
      "title": "Photos partagées",
      "empty": "Aucune photo partagée."
    },
    "couple": {
      "title": "Vous deux",
      "daysN": "{{n}} jours ensemble",
      "yourMood": "Ton humeur aujourd'hui",
      "anniversary": "Ensemble depuis"
    }
  }
}

export default translation
